
const Loading = () => {
  return (
    <div className="flex justify-center items-center py-8">
      <img
        src={require('../images/loading.gif')}
        className='w-40 object-cover'
      />
    </div>
  )
}

export default Loading